var styles = {"tend-ui-form-message-root":"tend-ui-form-message-root"};

export { styles as default };
